import React, {FC} from "react";
import {ActionTypes, ActionTypesLabels} from "services/abuseWordsService";
import {Apps, UserStatusEmojis, UserStatuses} from "enums";

export const AbuseActionTypeTag: FC<{ app?: Apps, action: ActionTypes }> = ({action, app}) => {
    const value: ActionTypes = action;
    const emoji: Record<ActionTypes | number, string> = {
        [ActionTypes.Ban]: UserStatusEmojis[UserStatuses.Banned],
        [ActionTypes.Suspicious]: UserStatusEmojis[UserStatuses.Suspicious],
        [ActionTypes.Hide]: '🙈',
        [ActionTypes.AdminCheck]: '🔖 ',
        [ActionTypes.NeedsVerification]: UserStatusEmojis[UserStatuses.NeedsVerification],
        [ActionTypes.ShadowBan]: UserStatusEmojis[UserStatuses.ShadowBan],
        [ActionTypes.Reject]: '🫸 ',
        1: '',
    }
    const string = `${emoji[value]} ${ActionTypesLabels(app)[value]}`
    return (
        <span className={`badge bg-secondary`}>{string}</span>
    );
}